<div class="ts1-maneuver-outcome">
	<div class="ts1-maneuver-outcome__header">Maneuver Outcome</div>

	<div class="ts1-maneuver-outcome__grid">
		<div class="ts1-maneuver-outcome__half">
			@for (row of displayRows; track row.slot) {
				@if (row.side === "left") {
					<div
						class="ts1-maneuver-outcome__row"
						[class.ts1-maneuver-outcome__row--readonly]="!isSlotInteractive(row.slot)"
					>
						<span
							class="ts1-maneuver-outcome__row-label"
							[class.ts1-maneuver-outcome__row-label--pf]="row.role === 'PF'"
							[class.ts1-maneuver-outcome__row-label--pm]="row.role === 'PM'"
						>
							{{ row.role }}
						</span>
						<div class="ts1-maneuver-outcome__options">
							@for (opt of ratingOptions; track opt) {
								<button
									type="button"
									class="ts1-maneuver-outcome__cell"
									[ngClass]="cellClasses(row.slot, opt)"
									[class.ts1-maneuver-outcome__cell--readonly]="!isSlotInteractive(row.slot)"
									[attr.aria-readonly]="!isSlotInteractive(row.slot) ? true : null"
									[attr.tabindex]="!isSlotInteractive(row.slot) ? -1 : null"
									(click)="select(row.slot, opt)"
								>
									{{ optionLabel(opt) }}
								</button>
							}
						</div>
					</div>
				}
			}
		</div>

		<div class="ts1-maneuver-outcome__divider"></div>

		<div class="ts1-maneuver-outcome__half">
			@for (row of displayRows; track row.slot) {
				@if (row.side === "right") {
					<div
						class="ts1-maneuver-outcome__row"
						[class.ts1-maneuver-outcome__row--readonly]="!isSlotInteractive(row.slot)"
					>
						<span
							class="ts1-maneuver-outcome__row-label"
							[class.ts1-maneuver-outcome__row-label--pf]="row.role === 'PF'"
							[class.ts1-maneuver-outcome__row-label--pm]="row.role === 'PM'"
						>
							{{ row.role }}
						</span>
						<div class="ts1-maneuver-outcome__options">
							@for (opt of ratingOptions; track opt) {
								<button
									type="button"
									class="ts1-maneuver-outcome__cell"
									[ngClass]="cellClasses(row.slot, opt)"
									[class.ts1-maneuver-outcome__cell--readonly]="!isSlotInteractive(row.slot)"
									[attr.aria-readonly]="!isSlotInteractive(row.slot) ? true : null"
									[attr.tabindex]="!isSlotInteractive(row.slot) ? -1 : null"
									(click)="select(row.slot, opt)"
								>
									{{ optionLabel(opt) }}
								</button>
							}
						</div>
					</div>
				}
			}
		</div>
	</div>
</div>
